import { Pipe, PipeTransform } from "@angular/core";
import { UiI18nService } from "../services/i18n.service";

@Pipe({
  name: "uiI18n",
})
export class UiI18nPipe implements PipeTransform {
  constructor(private i18n: UiI18nService) {}

  public transform(path: string, keyValue?: object): string {
    return this.i18n.translate(path, keyValue);
  }
}
